module.exports = __webpack_public_path__ + "img/33_36.3985c2f8.png";